import React from 'react';
import styled from 'styled-components';

import StartDatePreset from '../StartDatePreset';

import { ConditionalScrollable } from '../../../Scrollable';

import type { IStartDatePresetCategory } from './types';

export const StartDatePresetCategory = (props: IStartDatePresetCategory): JSX.Element | null => {
  const { icon: Icon, presets, selectedPreset, selectPreset, isMobile } = props;

  if (!presets[0][0]) return null;

  return (
    <PresetCategoryContainer $isMobile={isMobile}>
      <Icon />
      <ConditionalScrollable offset={48} applyScroll={isMobile}>
        <PresetsContainer>
          {presets.map((presetsRow) => (
            <PresetsRowContainer key={presetsRow[0].name}>
              {presetsRow.map(({ name, title, disabled }) => (
                <StartDatePreset
                  key={name}
                  name={name}
                  title={title}
                  disabled={disabled}
                  isSelected={name === selectedPreset}
                  handleClick={() => selectPreset(name)}
                  isMobile={isMobile}
                />
              ))}
            </PresetsRowContainer>
          ))}
        </PresetsContainer>
      </ConditionalScrollable>
    </PresetCategoryContainer>
  );
};

const PresetCategoryContainer = styled.div<{ $isMobile: boolean }>`
  margin: 4px 0 0 40px;

  ${({ $isMobile }) =>
    $isMobile &&
    `
      margin: 4px 0 0 0;
    `}
`;

const PresetsRowContainer = styled.div`
  display: flex;
`;

const PresetsContainer = styled.div`
  display: inline-block;
`;
